var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "source-state-list tw-flex tw-flex-col tw-overflow-hidden tw-rounded tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-4",
    staticStyle: {
      "height": "320px"
    }
  }, [_c('div', {
    staticClass: "tw-mb-3 tw-flex tw-shrink-0 tw-items-center tw-justify-between"
  }, [_c('h3', {
    staticClass: "tw-mb-0 tw-text-base tw-font-semibold"
  }, [_vm._v(" Include states ")]), _vm.sourceDoctor && !_vm.loadingSummary ? _c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" " + _vm._s(_vm.selectedCounterLabel) + " ")]) : _vm._e()]), !_vm.sourceDoctor ? _c('div', {
    staticClass: "tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-text-center"
  }, [_c('span', {
    staticClass: "tw-text-xs tw-text-gray-400"
  }, [_vm._v(" Select a source doctor above to see the states and patient counts available for transfer. ")])]) : _vm.loadingSummary ? _c('div', {
    staticClass: "tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-2"
  }, [_c('IconLoading', {
    staticClass: "tw-size-5 tw-text-primary"
  }), _c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v("Loading states…")])], 1) : [_c('b-input-group', {
    staticClass: "state-search tw-mb-3 tw-shrink-0 tw-rounded tw-bg-white"
  }, [_c('b-input-group-prepend', [_c('b-input-group-text', {
    staticClass: "tw-border-0 tw-bg-transparent"
  }, [_c('b-icon-search', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1), _c('b-form-input', {
    staticClass: "grow-1 tw-border-0 tw-p-0",
    attrs: {
      "placeholder": "Search states...",
      "type": "search",
      "autocomplete": "off"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm.search.length > 0 ? _c('b-input-group-prepend', {
    staticClass: "p-0"
  }, [_c('b-input-group-text', {
    staticClass: "p-0 tw-border-0 tw-bg-transparent"
  }, [_c('b-button', {
    staticClass: "border-0 align-self-center p-0",
    attrs: {
      "variant": "outline-white"
    },
    on: {
      "click": function ($event) {
        _vm.search = '';
      }
    }
  }, [_c('b-icon-x-circle', {
    staticClass: "tw-text-eclipse"
  })], 1)], 1)], 1) : _vm._e()], 1), _c('div', {
    staticClass: "tw-mb-2 tw-flex tw-shrink-0 tw-items-center tw-justify-between"
  }, [_c('b-form-checkbox', {
    attrs: {
      "checked": _vm.allSelected
    },
    on: {
      "change": _vm.onToggleAll
    }
  }, [_vm._v(" Select all ")]), _c('a', {
    staticClass: "text-secondary text-small",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        return _vm.onToggleAll(false);
      }
    }
  }, [_vm._v(" Clear ")])], 1), _c('div', {
    staticClass: "state-rows tw-min-h-0 tw-flex-1"
  }, [_vm._l(_vm.filteredStates, function (state) {
    return _c('div', {
      key: state.abbr,
      staticClass: "tw-flex tw-items-start tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3"
    }, [_c('b-form-checkbox', {
      staticClass: "tw-mt-0.5 tw-shrink-0",
      attrs: {
        "value": state.abbr,
        "disabled": state.total === 0
      },
      model: {
        value: _vm.selectedStates,
        callback: function ($$v) {
          _vm.selectedStates = $$v;
        },
        expression: "selectedStates"
      }
    }), _c('div', [_c('span', {
      staticClass: "tw-text-sm tw-font-semibold"
    }, [_vm._v(_vm._s(state.name))]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" (" + _vm._s(state.abbr) + ")")]), !state.licensed ? _c('b-badge', {
      staticClass: "tw-ml-2 tw-text-xs",
      attrs: {
        "variant": "warning"
      }
    }, [_vm._v(" NOT LICENSED ")]) : _vm._e(), _c('div', {
      staticClass: "text-small tw-mt-1"
    }, [_c('span', {
      staticClass: "tw-font-semibold"
    }, [_vm._v(_vm._s(state.total))]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" Total ·")]), _c('span', {
      staticClass: "tw-font-semibold"
    }, [_vm._v(" " + _vm._s(state.active))]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" Active ·")]), _c('span', {
      staticClass: "tw-font-semibold"
    }, [_vm._v(" " + _vm._s(state.cancelled))]), _c('span', {
      staticClass: "text-muted"
    }, [_vm._v(" Cancelled")])])], 1)], 1);
  }), !_vm.filteredStates.length ? _c('div', {
    staticClass: "tw-py-8 tw-text-center"
  }, [_c('span', {
    staticClass: "text-muted text-small"
  }, [_vm._v(" " + _vm._s(_vm.search.trim() ? `No states match "${_vm.search.trim()}"` : 'No states found.') + " ")])]) : _vm._e()], 2)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };